var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('alert-component'),_c('error-overlay'),_c('loading-overlay'),(_vm.isAuthenticated)?_c('authenticated-context'):_c('unauthenticated-context')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }